<template>
  <b-sidebar
    id="add-address-sidebar"
    :visible="show"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(visible) => $emit('update:show', visible)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ addressData ? 'Editar dirección' : 'Agregar dirección' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer
        ref="addressRules"
      >
        <b-form class="p-2">
          <b-row>
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                name="nombre de la dirección"
                rules="required"
              >
                <b-form-group
                  label="Nombre de la dirección:"
                  label-for="input-name"
                >
                  <b-form-input
                    id="input-name"
                    v-model="form.name"
                    placeholder="Ej: Casa, Oficina, Local, etc."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="nombre"
                rules="required"
              >
                <b-form-group
                  label="Nombre de quien recibe:"
                  label-for="input-receiver"
                >
                  <b-form-input
                    id="input-receiver"
                    v-model="form.receiver_name"
                    placeholder="Nombre de quien recibe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="teléfono"
                rules="required"
              >
                <b-form-group
                  label="Celular:"
                  label-for="input-phone"
                >
                  <cleave
                    id="input-phone"
                    v-model="form.phone"
                    class="form-control"
                    :raw="false"
                    :options="options.cellphoneDelimiter"
                    placeholder="Número de celular"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="departamento"
                rules="required"
              >
                <b-form-group
                  label="Departamento:"
                  label-for="select-department"
                >
                  <v-select
                    id="select-department"
                    v-model="form.department"
                    :options="Object.keys(departments)"
                    placeholder="Selecciona un departamento"
                    @input="onDepartmentChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="municipio"
                rules="required"
              >
                <b-form-group
                  label="Municipio:"
                  label-for="select-municipality"
                >
                  <v-select
                    id="select-municipality"
                    v-model="form.municipality"
                    :options="municipalities"
                    placeholder="Selecciona un municipio"
                    :disabled="!form.department"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="dirección"
                rules="required"
              >
                <b-form-group
                  label="Dirección exacta:"
                  label-for="textarea-address"
                >
                  <b-form-textarea
                    id="textarea-address"
                    v-model="form.address"
                    placeholder="Dirección exacta"
                    rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <b-form-group
                label="Referencia o indicaciones (opcional):"
                label-for="textarea-reference"
              >
                <b-form-textarea
                  id="textarea-reference"
                  v-model="form.reference"
                  placeholder="Referencias o indicaciones adicionales"
                  rows="2"
                />
              </b-form-group>

              <b-form-group>
                <div class="mt-1">
                  <b-form-checkbox
                    v-model="form.is_default"
                    v-b-tooltip.hover
                    name="is-default"
                    class="custom-control-primary"
                    title="Esta dirección se usará por defecto en las transacciones"
                  >
                    Establecer como dirección predeterminada
                  </b-form-checkbox>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              @click="submitForm"
            >
              {{ addressData ? 'Actualizar' : 'Guardar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import departments from '@/utils/data/guatemala'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'CustomersAddressForm',

  components: {
    ValidationProvider,
    ValidationObserver,
    Cleave,
    vSelect,
  },

  directives: {
    Ripple,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customerId: {
      type: Number,
      required: true,
    },
    addressData: {
      type: Object,
      default: null,
    },
    customerData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      departments,
      municipalities: [],
      form: {
        name: '',
        receiver_name: '',
        phone: '',
        department: '',
        municipality: '',
        address: '',
        reference: '',
        is_default: false,
      },
      options: {
        cellphoneDelimiter: {
          delimiters: ['-'],
          blocks: [4, 4],
          uppercase: true,
        },
      },
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        // Limpiar validaciones anteriores
        this.$nextTick(() => {
          if (this.$refs.addressRules) {
            this.$refs.addressRules.reset()
          }
        })

        if (this.addressData) {
          this.fillForm()
        } else {
          this.resetForm()
          // Autocompletar con datos del cliente al crear nueva dirección
          this.autoFillCustomerData()
        }
      }
    },
  },

  methods: {
    fillForm() {
      this.form = {
        name: this.addressData.name || '',
        receiver_name: this.addressData.receiver_name || '',
        phone: this.addressData.phone || '',
        department: this.addressData.department || '',
        municipality: this.addressData.municipality || '',
        address: this.addressData.address || '',
        reference: this.addressData.reference || '',
        is_default: this.addressData.is_default || false,
      }
      this.onDepartmentChange()
    },

    resetForm() {
      this.form = {
        name: '',
        receiver_name: '',
        phone: '',
        department: '',
        municipality: '',
        address: '',
        reference: '',
        is_default: false,
      }
      this.municipalities = []
    },

    autoFillCustomerData() {
      // Autocompletar con datos del cliente si están disponibles
      if (this.customerData) {
        this.form.receiver_name = this.customerData.name || ''
        this.form.phone = this.customerData.cellphone || this.customerData.phone || ''
      }
    },

    onDepartmentChange() {
      if (this.form.department && this.departments[this.form.department]) {
        this.municipalities = this.departments[this.form.department]
        // Solo limpiar municipio si no estamos editando
        if (!this.addressData) {
          this.form.municipality = ''
        }
      } else {
        this.municipalities = []
        // Solo limpiar municipio si no estamos editando
        if (!this.addressData) {
          this.form.municipality = ''
        }
      }
    },

    submitForm() {
      this.$refs.addressRules.validate().then(success => {
        if (success) {
          const addressData = {
            name: this.form.name,
            receiver_name: this.form.receiver_name,
            phone: this.form.phone,
            department: this.form.department,
            municipality: this.form.municipality,
            address: this.form.address,
            reference: this.form.reference,
            is_default: this.form.is_default,
          }

          if (this.addressData && this.addressData.id) {
            // Actualizar dirección existente
            axios
              .put(`customer/${this.customerId}/addresses/${this.addressData.id}`, addressData)
              .then(() => {
                this.makeToast('success', 'Dirección actualizada', 'La dirección ha sido actualizada exitosamente.')
                this.$emit('refresh-data')
                this.$emit('update:show', false)
              })
              .catch(error => {
                this.showErrors(error)
              })
          } else {
            // Crear nueva dirección
            axios
              .post(`customer/${this.customerId}/addresses`, addressData)
              .then(() => {
                this.makeToast('success', 'Dirección agregada', 'La dirección ha sido agregada exitosamente.')
                this.$emit('refresh-data')
                this.$emit('update:show', false)
              })
              .catch(error => {
                this.showErrors(error)
              })
          }
        }
      })
    },

    makeToast(variant = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      })
    },

    showErrors(error) {
      if (error.response && error.response.data && error.response.data.message) {
        this.$bvToast.toast(error.response.data.message, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } else {
        this.$bvToast.toast('Ha ocurrido un error inesperado', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-sidebar-header {
  border-bottom: 1px solid #ebe9f1;
}

.custom-control-primary {
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #7367f0;
    background-color: #7367f0;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
